import router from './index'
import { RouteLocationRaw } from 'vue-router'
import RoutePathEnum from "./RoutePathEnum"
import store from '@/store/BookingStore'

const navigateToPath = (options: RouteLocationRaw) => {
    router.push(options)
}

export const setRouteQuery = (items: { [key: string]: string }) => {
    router.replace({ query: { ...items } })
}

export const navigateToFlight = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Flight, query: query || router.currentRoute.value.query })
}
export const navigateToTrain = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Train, query: query || router.currentRoute.value.query })
}
export const navigateToTransfer = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Transfer, query: query || router.currentRoute.value.query })
}
export const navigateToOptions = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.OptionsV2, query: query || router.currentRoute.value.query })
}
export const navigateToUserInfo = (query: { [key: string]: any } | null = null) => {
    const q = query || router.currentRoute.value.query
    if (store.getters.getIsWidgetMode) {
        navigateToPath({ path: RoutePathEnum.OptionsV2, query: q })
        return
    }
    navigateToPath({ path: RoutePathEnum.UserInfoV2, query: q })
}
export const navigateToPayment = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.PaymentV2, query: query || router.currentRoute.value.query })
}
export const navigateToConfirmation = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Success, query: query || router.currentRoute.value.query })
}
export const navigateToPaid = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Paid, query: query || router.currentRoute.value.query })
}
export const navigateToError = (query: { [key: string]: any } | null = null) => {
    navigateToPath({ path: RoutePathEnum.Error, query: query || router.currentRoute.value.query })
}

export default navigateToPath